import { useEffect, useState } from "react";
import { Assort } from "../../app/models/Assort";
import { t } from "i18next";

const useGetLowestPrice = (tickets: Assort[], isDesktop: boolean, shouldAddLabel: boolean = true) => {
  const [loadingMessage, setLoadingMessage] = useState<string>("");

  useEffect(() => {
    if (tickets.length === 0) {
      setLoadingMessage("Ładowanie...");

      const timer = setTimeout(() => {
        setLoadingMessage("Brak biletów");
      }, 5000);

      return () => clearTimeout(timer);
    } else {
      const lowestPrice = tickets.reduce((r, b) => Math.min(r, b.price), tickets[0].price);

      const priceMessage = isDesktop
        ? `${t("ceny_od")} ${lowestPrice} ${t("zl")}`
        : `${t("od")} ${lowestPrice} ${t("zl")}`;

      setLoadingMessage(shouldAddLabel ? priceMessage : lowestPrice.toString());
    }
    //eslint-disable-next-line
  }, [tickets, isDesktop]);

  return loadingMessage;
};

export default useGetLowestPrice;
